export default __webpack_public_path__ + "static/media/image.e-tech-devices-and-accessories-pvt-ltd.a5b4b71a.png";